import axios from 'axios'
import { capitalizeFirstLetter } from '@/helpers'

const addressCheckStore = {
    namespaced: true,
    state: {
        isAddressLoading: false,
        isModal: false,
        formData: {
            region: '',
            city: '',
            street: '',
            house: '',
            build: '',
            flat: ''
        },
        history: {
            list: [],
            pagination: {},
            show_adm: true
        },
        data: null,
        regions: null,
        pdfStyle: `
            .addr-pdf__article {
                border-bottom: 1.5px solid black;
                padding: 10px 0;
                margin-bottom: 50px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
            .addr-pdf__article .header-holder {
                width: 100%;
                display: flex;
                gap: 15px;
            }  
            .addr-pdf__article__text {
                width: 100%;
                display: inline-block;
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                color: #4771f3;
            }
                    
            .addr-pdf__header {
                padding: 5px 0;
                border-bottom: 1px solid #444;
            }
            .addr-pdf__header div {
                width: 100%;
                max-width: 200px;
                line-height: 32px;
                text-align: center;
                padding: 0 15px;
                border-radius: 3px;
                font-weight: 500;
                background-color: #4770F3;
                color: #FEFEFE;
                font-size: 14px;
            }   
            .addr-pdf__source {
                padding: 20px 0;
                font-weight: 500;
            }
            .addr-pdf__source h3 {
                display: inline;
                font-weight: 700;
            } 

            .addr-pdf__result { padding: 25px 0; }
            .ip, .ul, .fl { padding: 15px 0; }
            .ip, .ul, .fl h3 { text-align: left; }
            .ip, .ul, .fl ul { width: 100%; }
            .ip, .ul, .fl { display: block; }
            .print-main-title { mfont-weigth: 700; }
            .fl h3, .ip h3, .ul h3 { font-weight: 700; }
        `
    },
    mutations: {
        setDataValue(state, { key, value }) { state.formData[key] = value },
        clearData(state) {
            const keys = Object.keys(state.formData)
            keys.forEach(key => state.formData[key] = '')
        },
        setHistoryList(state, value) { state.history.list = value },
        setHistoryPagination(state, value) { state.history.pagination = value },
        setRegions(state, value) { state.regions = value },
        changeLoading(state, value) { state.isAddressLoading = value },
        toggleModal(state, value) { state.isModal = value },
        setData(state, value) { state.data = value },
        setShowAdm(state, value) { state.history.show_adm = value }
        
    },
    actions: {
        getHistory({ commit }, { dateFrom, dateTo, search, filterGroups, filterUsers, show_adm, limit = 50, offset = 0 }) {
            return axios({
                baseURL: process.env.API_FL,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    method: 'addr_fl',
                    auth: {
                        sid: window.apiSession,
                    },
                    data: {
                        action: 'getHistory',
                        dateFrom,
                        dateTo,
                        search,
                        filterGroups,
                        filterUsers,
                        show_adm,
                        limit,
                        offset 
                    }
                }
            }).then(e => {
                commit('setHistoryList', e?.data?.data?.history ?? [])
                commit('setHistoryPagination', e?.data?.data?.pagination)
            }).catch(err => {
                console.log(err)
            })
        },
        getRegions({commit}) {
            return axios({
                baseURL: process.env.API_FL,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    method: 'addr_fl',
                    auth: {
                        sid: window.apiSession,
                    },
                    data: { action: 'getRegions' }
                }
            }).then(e => {
                commit('setRegions', e?.data?.data)
            }).catch(err => {
                console.log(err)
            })
        },
        checkAddress({ dispatch, commit, state }, data) {
            const { region, city, street, house, build, flat } = data
            
            return axios({
                baseURL: process.env.API_FL,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    method: 'addr_fl',
                    auth: {
                        sid: window.apiSession,
                    },
                    data: {
                        action: 'getData',
                        region,
                        city: capitalizeFirstLetter(city),
                        street: capitalizeFirstLetter(street),
                        house,
                        build,
                        flat
                    }
                }
            }).then(e => {
                commit('changeLoading', false)
            if(e?.data?.auth?.code !== 0) {    
                switch(e?.data?.auth?.code){
                    case 9:
                        this.dispatch("showErrorPopUp", 'Превышен лимит запросов', { root: true })
                        break
                    default:
                        this.dispatch("showErrorPopUp", 'Ошибка авторизации: ' + e.data.auth.message, { root: true })
                        break       
                }
            } else if(e?.data?.code !== 0) {
                    switch(parseInt(e?.data?.code)) {
                        case 165:
                            dispatch('showErrorPopUp', `Превышено время ожидания`, { root:true })
                            break
                        case 106:
                            dispatch('showErrorPopUp', `Превышен лимит по запросу, обратитесь в службу технической поддержки.`, { root: true })
                            break
                        default:
                            dispatch('showErrorPopUp', `Произошла ошибка, попробуйте позже или обратитесь в службу технической поддержки.`, { root: true })
                    }
                } else {       
                    commit('setData', e?.data?.data)
                    commit('toggleModal', true) 
                }
            }).catch(err => {
                commit('changeLoading', false)
                console.log(err)
            }).finally(() => {
                dispatch('getHistory', { limit: 50, offset: 0, show_adm: state.history.show_adm })
            })            
        }
    },
    getters: {
        isValidForm({ formData }) {
            const { region, city, street, house } = formData
            if(region && city && street && house) {
                return true
            } else {
                return false
            }
        },
        regionsKeys({ regions }) {
            if(regions) {
                return Object.keys(regions)
            } else {
                return []
            }
        }

    }
}

export default addressCheckStore